const ACTIONS = {
    FETCH_URGENCY_MESSAGE: 'LISTING_EXTENDED/FETCH_URGENCY_MESSAGE', // => middleware
    FETCH_URGENCY_MESSAGE_SUCCESS: 'LISTING_EXTENDED/FETCH_URGENCY_MESSAGE_SUCCESS', // => reducer
    FETCH_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_BADGES_SUCCESS',
    FETCH_UNIT_SPACES_SUCCESS: 'LISTING_EXTENDED/FETCH_UNIT_SPACES_SUCCESS',
    FETCH_CONTENT_ITEMS_SUCCESS: 'LISTING_EXTENDED/FETCH_CONTENT_ITEMS_SUCCESS',
    FETCH_IMAGE_METADATA_SUCCESS: 'LISTING_EXTENDED/FETCH_IMAGE_METADATA_SUCCESS'
};

const ACTION_CREATORS = {
    fetchUrgencyMessage(arriveDateText, departDateText) {
        return {
            type: ACTIONS.FETCH_URGENCY_MESSAGE,
            payload: {
                arriveDateText,
                departDateText
            }
        };
    },
    fetchUrgencyMessageSuccess(urgencyMessage) {
        return {
            type: ACTIONS.FETCH_URGENCY_MESSAGE_SUCCESS,
            payload: {
                urgencyMessage
            }
        };
    },
    fetchBadgesSuccess(badges) {
        return {
            type: ACTIONS.FETCH_BADGES_SUCCESS,
            payload: {
                badges
            }
        };
    },
    fetchUnitSpacesSuccess(unitSpaces) {
        return {
            type: ACTIONS.FETCH_UNIT_SPACES_SUCCESS,
            payload: {
                unitSpaces
            }
        };
    },
    fetchContentItemsSuccess(unitContentItems, propertyContentItems, unitMetadata) {
        return {
            type: ACTIONS.FETCH_CONTENT_ITEMS_SUCCESS,
            payload: {
                unitContentItems,
                propertyContentItems,
                unitMetadata
            }
        };
    },
    fetchImageMetadataSuccess(imageMetadata) {
        return {
            type: ACTIONS.FETCH_IMAGE_METADATA_SUCCESS,
            payload: {
                imageMetadata
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
